var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "bairun-absolute-container bairun-bianlidian-stock" },
    [
      _c("el-header", { staticClass: "bairun-header" }, [
        _c(
          "div",
          { staticClass: "search-term" },
          [
            _c(
              "el-form",
              { attrs: { inline: true } },
              [
                _c(
                  "el-popover",
                  {
                    directives: [
                      {
                        name: "mobile",
                        rawName: "v-mobile",
                        value: true,
                        expression: "true"
                      }
                    ],
                    attrs: { placement: "right-end", trigger: "click" },
                    model: {
                      value: _vm.showSelSeller,
                      callback: function($$v) {
                        _vm.showSelSeller = $$v
                      },
                      expression: "showSelSeller"
                    }
                  },
                  [
                    _vm.sellerOptions.length > 1
                      ? _c(
                          "el-radio-group",
                          {
                            staticClass: "bairun-search-sellers",
                            attrs: { size: "mini" },
                            on: { change: _vm.onSubmit },
                            model: {
                              value: _vm.searchInfo.sellerId,
                              callback: function($$v) {
                                _vm.$set(_vm.searchInfo, "sellerId", $$v)
                              },
                              expression: "searchInfo.sellerId"
                            }
                          },
                          [
                            _c(
                              "el-radio",
                              { attrs: { label: 0, border: "" } },
                              [_vm._v("总")]
                            ),
                            _vm._l(_vm.sellerOptions, function(item) {
                              return _c(
                                "el-radio",
                                { attrs: { label: item.sellerId, border: "" } },
                                [_vm._v(_vm._s(item.shortSellerName))]
                              )
                            })
                          ],
                          2
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      { attrs: { slot: "reference" }, slot: "reference" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("getSellerShortName")(
                              _vm.searchInfo.sellerId
                            )
                          )
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm.sellerOptions.length > 1
                  ? _c(
                      "el-radio-group",
                      {
                        directives: [
                          {
                            name: "mobile",
                            rawName: "v-mobile",
                            value: false,
                            expression: "false"
                          }
                        ],
                        staticClass: "bairun-search-sellers",
                        attrs: { size: "mini" },
                        on: { change: _vm.onSubmit },
                        model: {
                          value: _vm.searchInfo.sellerId,
                          callback: function($$v) {
                            _vm.$set(_vm.searchInfo, "sellerId", $$v)
                          },
                          expression: "searchInfo.sellerId"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 0, border: "" } }, [
                          _vm._v("总")
                        ]),
                        _vm._l(_vm.sellerOptions, function(item) {
                          return _c(
                            "el-radio",
                            { attrs: { label: item.sellerId, border: "" } },
                            [_vm._v(_vm._s(item.shortSellerName))]
                          )
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _c(
                  "div",
                  [
                    _c("el-input", {
                      attrs: { placeholder: "商品名称", clearable: "" },
                      model: {
                        value: _vm.searchInfo.goodsName,
                        callback: function($$v) {
                          _vm.$set(_vm.searchInfo, "goodsName", $$v)
                        },
                        expression: "searchInfo.goodsName"
                      }
                    })
                  ],
                  1
                ),
                _c("el-button", { on: { click: _vm.onSubmit } }, [
                  _vm._v("查询")
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("el-main", { staticClass: "bairun-main" }, [
        _c("div", { staticClass: "bairun-padding" }, [
          _c(
            "div",
            { staticClass: "divider-title" },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "mini" },
                  on: { change: _vm.onCheckTab },
                  model: {
                    value: _vm.checkTab,
                    callback: function($$v) {
                      _vm.checkTab = $$v
                    },
                    expression: "checkTab"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: "shishi" } }, [
                    _vm._v("实时")
                  ]),
                  _c("el-radio-button", { attrs: { label: "linqi" } }, [
                    _vm._v("临期")
                  ]),
                  _c("el-radio-button", { attrs: { label: "jiya" } }, [
                    _vm._v("积压")
                  ]),
                  _c("el-radio-button", { attrs: { label: "guoqi" } }, [
                    _vm._v("过期")
                  ])
                ],
                1
              ),
              _c(
                "el-button",
                {
                  staticClass: "right",
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-download"
                  },
                  on: { click: _vm.onDownload }
                },
                [_vm._v("下载")]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "shishi",
                  expression: "checkTab === 'shishi'"
                }
              ]
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.shishiTable.table }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.goodsName))]),
                            _c("div", [
                              _vm._v(
                                _vm._s(scope.row.goodsSpecification) +
                                  "/" +
                                  _vm._s(scope.row.goodsUnit)
                              )
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "类目", prop: "categoryName" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.categoryName))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "实时库存" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.goodsStock))])
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  small: "",
                  "hide-on-single-page": true,
                  "pager-count": 5,
                  "current-page": _vm.shishiTable.page,
                  "page-size": _vm.shishiTable.pageSize,
                  total: _vm.shishiTable.total,
                  layout: "total, prev, pager, next"
                },
                on: {
                  "current-change": _vm.handleShishiCurrentChange,
                  "size-change": _vm.handleShishiSizeChange
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "linqi",
                  expression: "checkTab === 'linqi'"
                }
              ]
            },
            [
              _c("el-alert", {
                staticClass: "bairun-margin-t",
                attrs: { title: "有效期低于30天", type: "warning" }
              }),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.linqiTable.table }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "便利店", prop: "sellerName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "规格", prop: "goodsSpecification" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "单位", prop: "goodsUnit" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "库存数", prop: "totalGoodsNum" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "生产日期", prop: "dateStart" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate2")(scope.row.dateStart))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "保质期至", prop: "dateEnd" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate2")(scope.row.dateEnd))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "入库批次号", prop: "goodsInNo" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onViewGoodsInDetail(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(scope.row.goodsInNo))]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  small: "",
                  "hide-on-single-page": true,
                  "pager-count": 5,
                  "current-page": _vm.linqiTable.page,
                  "page-size": _vm.linqiTable.pageSize,
                  total: _vm.linqiTable.total,
                  layout: "total, prev, pager, next"
                },
                on: {
                  "current-change": _vm.handleLinqiCurrentChange,
                  "size-change": _vm.handleLinqiSizeChange
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "jiya",
                  expression: "checkTab === 'jiya'"
                }
              ]
            },
            [
              _c("el-alert", {
                staticClass: "bairun-margin-t",
                attrs: { title: "存放超60天", type: "warning" }
              }),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.jiyaTable.table }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "便利店", prop: "sellerName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "规格", prop: "goodsSpecification" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "单位", prop: "goodsUnit" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "进货日期", prop: "dateStart" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate2")(scope.row.createdAt))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "最近销售日期", prop: "dateEnd" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.lastSaleDate
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatDate2")(
                                        scope.row.lastSaleDate
                                      )
                                    )
                                  )
                                ])
                              : _c("span", [_vm._v("无")])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "库龄(天)", prop: "stockAge" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "库存数", prop: "totalGoodsNum" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "入库批次号", prop: "goodsInNo" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onViewGoodsInDetail(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(scope.row.goodsInNo))]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  small: "",
                  "hide-on-single-page": true,
                  "pager-count": 5,
                  "current-page": _vm.jiyaTable.page,
                  "page-size": _vm.jiyaTable.pageSize,
                  total: _vm.jiyaTable.total,
                  layout: "total, prev, pager, next"
                },
                on: {
                  "current-change": _vm.handleJiyaCurrentChange,
                  "size-change": _vm.handleJiyaSizeChange
                }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.checkTab === "guoqi",
                  expression: "checkTab === 'guoqi'"
                }
              ]
            },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.guoqiTable.table }
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "便利店", prop: "sellerName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品名称", prop: "goodsName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "规格", prop: "goodsSpecification" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "单位", prop: "goodsUnit" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "库存数", prop: "totalGoodsNum" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "生产日期", prop: "dateStart" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate2")(scope.row.dateStart))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "保质期至", prop: "dateEnd" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm._f("formatDate2")(scope.row.dateEnd))
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "入库批次号", prop: "goodsInNo" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-link",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.onViewGoodsInDetail(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(scope.row.goodsInNo))]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  small: "",
                  "hide-on-single-page": true,
                  "pager-count": 5,
                  "current-page": _vm.guoqiTable.page,
                  "page-size": _vm.guoqiTable.pageSize,
                  total: _vm.guoqiTable.total,
                  layout: "total, prev, pager, next"
                },
                on: {
                  "current-change": _vm.handleGuoqiCurrentChange,
                  "size-change": _vm.handleGuoqiSizeChange
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }